import React from "react";
import profileImg from "../../../images/profile.png";

import {
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@mui/material";
import PhoneBluetoothSpeakerIcon from "@mui/icons-material/PhoneBluetoothSpeaker";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { convertToRFT } from "../../../utils/convertToRFT";
import { BoxesPacking } from "../../features/BoxesPacking";
import moment from "moment";
import Img1 from "../../../images/ad.png";
export const CustomCell = styled(TableCell)({
  color: "#fff",
});
export const CustomTypo = styled(Stack)({
  border: "1px solid",
  borderColor: "lightgray",
  padding: 3,
  borderRadius: "4px",
});
function Preview1({ selectedColor, bill, fivePercent }) {
  let companyImg = localStorage.getItem("companyImg");
  const CustomHead = styled(TableHead)({
    background: selectedColor,
    "& th:first-child": {
      borderTopLeftRadius: "8px",
    },
    "& th:last-child": {
      borderTopRightRadius: "8px",
    },
  });
  const CustomBottom = styled(TableHead)({
    background: selectedColor,

    "& th:first-child": {
      borderBottomLeftRadius: "8px",
    },
    "& th:last-child": {
      borderBottomRightRadius: "8px",
    },
  });
  const findTotal = () => {
    let count = 0;
    bill?.items?.forEach((item) => {
      let { totalPrice } = convertToRFT(bill.saleType, item, "", "ignore");
      count += Math.ceil(totalPrice);
    });
    return count;
  };
  return (
    <>
      <Stack spacing={25} direction={"row"} sx={{ mt: 3 }}>
        <Stack
          justifyContent={"center"}
          alignItems={"start"}
          sx={{
            background: "#002984",
            width: "50%",
            position: "relative",
            borderBottomRightRadius: "50px",
            padding: 2,
            color: "#fff",
          }}>
          <img
            src={companyImg ? companyImg : profileImg}
            alt=""
            height={"50px"}
            width={"50px"}
          />
          <Typography> {localStorage.getItem("company")} </Typography>
        </Stack>
        <Stack
          direction={"row"}
          alignItems={"end"}
          spacing={5}
          sx={{
            background: selectedColor,
            width: "60%",
            position: "absolute",
            padding: 3,
            borderBottomLeftRadius: "50px",
            color: "#fff",
          }}>
          <Stack spacing={2} direction={"row"}>
            <PhoneBluetoothSpeakerIcon /> | {localStorage.getItem("phone")}
          </Stack>
          <Stack spacing={2} direction={"row"}>
            <EmailIcon /> | {localStorage.getItem("email")}
          </Stack>
          <Stack spacing={2} direction={"row"}>
            <LocationOnIcon /> | {localStorage.getItem("address")}
          </Stack>
        </Stack>
      </Stack>
      <Grid container justifyContent={"space-between"}>
        <Grid item={6} sx={{ mt: 2 }}>
          <Typography sx={{ color: selectedColor }}>Bill To : </Typography>
          <Typography>{localStorage.getItem("company")}</Typography>
        </Grid>
        <Grid item={6} sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: "30px", fontWeight: "bold" }}>
            Invoice
          </Typography>
          <Stack direction={"row"}>
            <Typography sx={{ fontWeight: "bold" }}>Invoice No: </Typography>
            <Typography>{bill.billNumber}</Typography>
          </Stack>
          <Stack direction={"row"}>
            <Typography sx={{ fontWeight: "bold" }}>Date: </Typography>
            <Typography>
              {bill.created_at
                ? moment.unix(bill.created_at).format("DD-MM-YYYY")
                : bill.date}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <TableContainer>
        <Table sx={{ minWidth: 650, mt: 3 }} size="small">
          <CustomHead>
            <TableRow>
              <CustomCell>#</CustomCell>
              <CustomCell>Item</CustomCell>
              <CustomCell>Description</CustomCell>

              <CustomCell>Qty</CustomCell>
              <CustomCell>Unit Price</CustomCell>
              <CustomCell>Total Price</CustomCell>
            </TableRow>
          </CustomHead>
          <TableBody>
            {bill?.items?.map((item, index) => {
              let bonus = parseInt(item?.bonus) || 0;
              let { unit, itemPrice, saleQty, totalPrice, itemDiscount } =
                convertToRFT(bill.saleType, item, "", fivePercent);
              let saleQuantity =
                saleQty % 1 === 0 ? saleQty : saleQty.toFixed(3);
              let boxes = 0;
              if (BoxesPacking()) {
                if (item.saleQuantity && item?.packing) {
                  let totalBox = parseFloat(item.saleQuantity) / item.packing;
                  boxes = totalBox % 1 === 0 ? totalBox : totalBox.toFixed(2);
                } else {
                  if (item.saleQuantity == undefined && item?.packing) {
                    let totalBox = 1 / item.packing;
                    boxes = totalBox % 1 === 0 ? totalBox : totalBox.toFixed(2);
                  } else {
                    boxes = "";
                  }
                }
              }
              return (
                <TableRow key={index}>
                  <TableCell component="th">{index + 1}</TableCell>
                  <TableCell component="th">{item.name}</TableCell>
                  <TableCell component="th">{item.description}</TableCell>
                  {/* {companyCode == 7149 || companyCode == 1178 ? null : (
                    <TableCell component="th">{itemDiscount}</TableCell>
                  )} */}

                  {BoxesPacking() ? (
                    <TableCell component="th">
                      <p style={{ margin: "0px", padding: "0px" }}>
                        {saleQuantity}
                        {item?.bonus && (
                          <Typography>Bonus : {item.bonus}</Typography>
                        )}
                      </p>
                      <p style={{ margin: "0px", padding: "0px" }}>
                        {boxes} boxes
                      </p>
                    </TableCell>
                  ) : (
                    <TableCell component="th">
                      <Stack>
                        {saleQuantity + " " + unit}
                        {item?.bonus && (
                          <Typography>Bonus : {item.bonus}</Typography>
                        )}
                      </Stack>
                    </TableCell>
                  )}

                  <TableCell component="th">{itemPrice.toFixed(2)}</TableCell>
                  <TableCell component="th">{totalPrice}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          <CustomBottom>
            <TableRow>
              <CustomCell></CustomCell>
              <CustomCell>Total</CustomCell>
              <CustomCell>2</CustomCell>

              <CustomCell></CustomCell>
              <CustomCell></CustomCell>
              <CustomCell>Rs 2000</CustomCell>
            </TableRow>
          </CustomBottom>
        </Table>
      </TableContainer>
      <Stack
        justifyContent={"space-between"}
        direction={"row"}
        sx={{ mt: 3 }}
        spacing={1}>
        <Stack>
          <Typography sx={{ color: selectedColor, fontSize: "18px" }}>
            Invoice Amount In Words
          </Typography>
          <Typography>Six hundreds rupees only</Typography>
          <Typography sx={{ color: selectedColor, mt: 1, fontSize: "18px" }}>
            Terms And Condition
          </Typography>
          <Typography sx={{ color: selectedColor }}>
            For Infini8aiStore
          </Typography>
          <Typography>Authorized Signature</Typography>
        </Stack>
        <Stack sx={{ width: "50%", mt: 3 }}>
          <CustomTypo direction={"row"} justifyContent={"space-between"}>
            <Typography>SubTotal</Typography>
            <Typography>{bill.subTotal}</Typography>
          </CustomTypo>
          <CustomTypo>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              sx={{
                background: selectedColor,
                borderBottomLeftRadius: "25px",
                padding: 1,
              }}>
              <Typography>Total</Typography>
              <Typography>{findTotal()}</Typography>
            </Stack>
          </CustomTypo>
          <CustomTypo direction={"row"} justifyContent={"space-between"}>
            <Typography>Received</Typography>
            <Typography>{bill.paid}</Typography>
          </CustomTypo>
          <CustomTypo direction={"row"} justifyContent={"space-between"}>
            <Typography>Total</Typography>
            <Typography>{bill.total}</Typography>
          </CustomTypo>
        </Stack>
      </Stack>
    </>
  );
}

export default Preview1;
